import {
  Box,
  Fab,
  Link,
  Typography,
} from '@mui/material'
import { Info } from '@mui/icons-material'
import { TpTooltip } from '~/components/tp-tooltip'

const LEAVE_DELAY = 500

export const DtmDisclaimerTooltip = () => {
  return (
    <TpTooltip
      title={
        <Box >
          <Typography>
            Crop schedules are based on a template location to represent the days to maturity (DTM).
            <br/>
            Your farm’s average daily growing degree days with base temperatures of 5°C and 10°C are used
            to best approximate the conversion of the template crop DTM's to the DTM for this crop planted on your farm.
            <br/>
          </Typography>
        </Box>
      }
      placement="top"
      enterTouchDelay={0}
      followCursor={false}
      leaveTouchDelay={LEAVE_DELAY}
      leaveDelay={LEAVE_DELAY}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -12],
              },
            },
          ],
        },
      }}
    >
      <Fab
        size="small"
        disableRipple
        disableFocusRipple
        tabIndex={-1}
        sx={{
          position: 'absolute',
          top: 14,
          right: 16,
          bgcolor: 'background.paper',
          boxShadow: 'none',
          pointerEvents: 'hover',
          cursor: 'unset',
          '&:active': {
            boxShadow: 'none',
            bgcolor: 'background.paper',
          },
          '&:hover': {
            bgcolor: 'background.paper',
          }
        }}
      >
        <Info color='primary' />
      </Fab>
    </TpTooltip>
  )
}